import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'
import { DBCheckBoxComment } from '_components'

class PatientCareCenterNoteObjectiveObsOccupationImpairmentsPeds extends React.Component {
    render() {
        
            return (
                <PatientCareCenterNoteSection id='obj_obs_occ_impair' name='Occupation Impairments' level={2} noChildPadding={true}>
                     <div className={styles.form_row}>
                        <div className={styles.gap}>
                          <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPOCCREST'
                         className={styles.checkbox}
                         label='Rest and Sleep'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                        <div className={styles.gap}>
                          <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPOCCEDU'
                         className={styles.checkbox}
                         label='Education'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                        <div className={styles.gap}>
                          <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPOCCPLAY'
                         className={styles.checkbox}
                         label='Play'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                        <div className={styles.gap}>
                          <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPOCCLEISURE'
                         className={styles.checkbox}
                         label='Leisure'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                        <div className={styles.gap}>
                          <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPOCCSOCIAL'
                         className={styles.checkbox}
                         label='Social Participation'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>
                </PatientCareCenterNoteSection>
            );
       
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        opno: opno
    };
}

const connectedPatientCareCenterNoteObjectiveObsOccupationImpairmentsPeds = connect(mapStateToProps)(PatientCareCenterNoteObjectiveObsOccupationImpairmentsPeds);
export { connectedPatientCareCenterNoteObjectiveObsOccupationImpairmentsPeds as PatientCareCenterNoteObjectiveObsOccupationImpairmentsPeds };

